if (!customElements.get('sticky-header')) {
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector(".shopify-section-header"),
      this.headerWrapper = document.querySelector(".header-wrapper"),
      this.headerIsAlwaysSticky = this.getAttribute("data-sticky-type") === "always",
      this.headerBounds = {},
      this.currentScrollTop = 0,
      this.preventReveal = !1,
      this.predictiveSearch = this.querySelector("predictive-search"),
      this.onScrollHandler = this.onScroll.bind(this),
      this.hideHeaderOnScrollUp = () => this.preventReveal = !0,
      this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp),
      window.addEventListener("scroll", this.onScrollHandler, !1),
      this.createObserver();
    }
    disconnectedCallback() {
      this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp),
      window.removeEventListener("scroll", this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer2) => {
        this.headerBounds = entries[0].intersectionRect, observer2.disconnect();
      });
      this.header && observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // Note: this method intentionally no longer touches "color-background-2".
      // That class (the hero-transparency marker) is owned exclusively by
      // header.js's IntersectionObserver, which tracks the actual hero
      // section's visibility rather than a fixed header-height scroll
      // threshold. Having both scripts fight over the same class caused the
      // header to flicker solid/transparent on every scroll tick.
      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1 && (this.header.classList.add("shopify-section-header-sticky", "shopify-section-header-always-sticky"), this.header.style.transform = "translateY(-100%)"), this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2 && (this.header.style.transition = "background var(--duration-short)", this.header.style.transform = "translateY(0)"), this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight && (this.header.classList.remove("shopify-section-header-sticky"), this.header.style.transform = "translateY(0)", this.header.style.transition = "background var(--duration-short)"), scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom ? this.preventReveal ? (window.clearTimeout(this.isScrolling), this.isScrolling = setTimeout(() => { this.preventReveal = !1; }, 66), requestAnimationFrame(this.hide.bind(this))) : requestAnimationFrame(this.reveal.bind(this)) : scrollTop <= this.headerBounds.top && requestAnimationFrame(this.reset.bind(this));
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.headerIsAlwaysSticky || document.querySelector(".overflow-hidden-tablet") || (this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky"), this.closeMenuDisclosure());
    }
    reveal() {
      this.headerIsAlwaysSticky || (document.querySelector(".entering-section") ? (this.header.classList.add("shopify-section-header-sticky", "animate"), this.header.classList.remove("shopify-section-header-hidden")) : (this.header.classList.add("shopify-section-header-sticky", "animate"), this.header.classList.remove("shopify-section-header-hidden", "color-background-2")));
    }
    reset() {
      this.headerIsAlwaysSticky || (this.header.classList.remove("shopify-section-header-hidden", "shopify-section-header-sticky", "animate"), this.header.classList.contains("color-background-1") && this.header.classList.add("color-background-2"));
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll("details-disclosure"),
      this.disclosures && this.disclosures.forEach(disclosure => { disclosure.close(); }),
      this.disclosureLists = this.header.querySelectorAll(".disclosure__list"),
      this.disclosureLists && this.disclosureLists.forEach(disclosureList => { disclosureList.setAttribute("hidden", !0); });
    }
  }
  customElements.define("sticky-header", StickyHeader);
}
